<template>
  <div class="card_container">
    <div class="card_container_body">
      <div class="card_header_image_container">
        <div class="card_header_image_blocker"></div>
        <img class="card_header_image" :src="img" />
      </div>
      <div class="card_body">
        <div class="card_body_title">
          <span>
            <b>{{ title }}</b>
          </span>
        </div>
        <!-- <div class="card_body_description">
          {{ desc }}
        </div> -->
        <!-- <div class="card_body_cto">View</div> -->
        <!-- <div class="shane_tm_button small" style="float: none;">
          <a href="cv">
            View
          </a>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  // optional style for arrows & dots

export default {
  name: 'MyComponent',
  components: {},
  props: {
      img: String,
      title: String,
      desc: String,
  },
  data() {
    return {
      src: require('@/assets/img/backgrounds/cuttingBoardBackgroundNew.jpg')
    }
  }
}
</script>

<style lang="css">
.card_container {
  padding: 10px;
}
.card_container_body {
  /* background-repeat: ; */
  box-shadow: 0px 4px 10px #00000022;
  border-radius: 10px;
  transform: translateY(0px);
  transition: transform .4s ease, box-shadow .4s ease;
}
.card_container_body:hover {
  box-shadow: 0px 4px 15px #00000020;
  transform: translateY(-5px);
  cursor: pointer;
}
.card_header_image_container {
  /* background-image: url("~@/assets/img/backgrounds/woodbackground.jpg"); */
  /* background-size: cover; */
  width: 100%;
  border-radius: 10px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  overflow: hidden;
  position: relative;
  max-height: 150px;
  /* height: 300px; */
}
.card_header_image {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  /* margin-top: -25%; */
  /* padding: 10px; */
}
.card_header_image_blocker {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background: #00000022; */
  border-radius: 10px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  /* margin: 20px; */
}
.card_body {
  padding: 10px;
  padding-left: 20px;
}

.shane_tm_button.small a {
  padding: 2px 25px;
}
.card_body_description {
  margin-bottom: 20px;
  margin-top: 10px;
  line-height: 20px;
}
.card_body_cto {
  color: #aaa;
  margin-left: 0px;
  transition: color .4s ease, margin-left .4s ease;
}
.card_container_body:hover .card_body_cto {
  color: #555;
  margin-left: 5px;
}
</style>